/**
 * Condition quiz cards — replace image paths with your own photos in
 * public/assets/condition-quiz/ (e.g. quiz-01.jpg … quiz-10.jpg).
 */
export const CONDITION_QUIZ_ITEMS = [
  {
    id: 1,
    image: "/assets/condition-quiz/quiz-01.jpg",
    answer: "NM",
    note: "Only a couple of tiny whitening spots on the back corners — within our 0–3 NM range.",
  },
  {
    id: 2,
    image: "/assets/condition-quiz/quiz-02.jpg",
    answer: "LP",
    note: "Light whitening along the top edge and a small surface scuff on the holo.",
  },
  {
    id: 3,
    image: "/assets/condition-quiz/quiz-03.jpg",
    answer: "NM",
    note: "Clean front; back shows minimal edge wear with no creases or scratches.",
  },
  {
    id: 4,
    image: "/assets/condition-quiz/quiz-04.jpg",
    answer: "MP",
    note: "Whitening on multiple edges and visible print lines from handling.",
  },
  {
    id: 5,
    image: "/assets/condition-quiz/quiz-05.jpg",
    answer: "LP",
    note: "Slightly rounded corners and light edge whitening, but no major surface damage.",
  },
  {
    id: 6,
    image: "/assets/condition-quiz/quiz-06.jpg",
    answer: "HP",
    note: "Heavy corner wear and multiple surface scratches across the card face.",
  },
  {
    id: 7,
    image: "/assets/condition-quiz/quiz-07.jpg",
    answer: "MP",
    note: "Noticeable edge wear on three sides with a faint surface scratch near the art.",
  },
  {
    id: 8,
    image: "/assets/condition-quiz/quiz-08.jpg",
    answer: "DMG",
    note: "Visible crease through the card — automatic DMG regardless of other wear.",
  },
  {
    id: 9,
    image: "/assets/condition-quiz/quiz-09.jpg",
    answer: "HP",
    note: "Significant whitening and scuffing; corners are heavily worn but no structural crease.",
  },
  {
    id: 10,
    image: "/assets/condition-quiz/quiz-10.jpg",
    answer: "NM",
    note: "Three small whitening dots on the back only — still NM under our grading standard.",
  },
];

export const QUIZ_LENGTH = CONDITION_QUIZ_ITEMS.length;
